<template>
  <header class="main-header">
    <!-- Logo -->
    <div class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini">
        <b> <img src="/static/img/logo.png" alt="User Image"></b>
      </span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><img src="/static/img/logo.png" alt="User Image">
        <b>选型宝</b>管理后台
      </span>
    </div>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </a>
      
      <!--
      <div class="pull-left-search">
        <form id="demo-2">
          <input class="devin-search" type="search">
        </form> 
      </div>
      -->
  
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- Profile -->
          <!-- <li class="session-profile">
            <el-button type="info" icon="ti-user" circle></el-button>
            <span style="cursor:pointer">登录</span>
          </li> -->

          <li class="session-profile" v-if="$store.state.userInfo">
            <el-dropdown class="header-dropdown-devin" trigger="click" @command="handleLogout">
              <span class="el-dropdown-link">
                <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/img/avatar-bg.png'" alt="avatar">
                {{$store.state.userInfo.nickname}}
                <strong v-if="$store.getters.isAdmin" class="auth-tag">管理员</strong>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <!-- Messages: style can be found in dropdown.less --
          <li>
            <el-dropdown class="header-dropdown-devin" trigger="click">
              <span class="el-dropdown-link">
                <el-badge :value="20" :max="9" class="item">
                  <el-button type="text" size="small"><i class="ti-email"></i></el-button>
                </el-badge>
              </span>
              <el-dropdown-menu slot="dropdown">
                <ul class="dropdown-menu-devin">
                    <li class="header">You have 10+ Message</li>
                    <li>
                        <ul class="menu">
                            <li>
                                <a href="#">
                                    <h3>Announcements <span>Just Now !</span>
                                        </h3>
                                    <p>Pok ame ame belalang kupu kupu</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <h3>Complete your profile<span>2 Min Ago</span>
                                        </h3>
                                    <p>Siang makan nasi kalo malam minum susu</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <h3>New Schedule Realease<span>30 Min ago</span>
                                        </h3>
                                    <p>Bintang kecil dilangit yang tinggi</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <h3>New Student Data<span>1 Hour ago</span>
                                        </h3>
                                    <p>Amat banyak menghias angkasa</p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <h3>Graduate Student List<span>2 Days ago</span>
                                        </h3>
                                    <p>Aku ingin terbang dan melayang, jauh tinggi ke tempat kau berada</p>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="footer"><a href="#">View all</a></li>
                </ul>
              </el-dropdown-menu>
            </el-dropdown>
          </li>-->
          
          <!-- Notifications: style can be found in dropdown.less --
          <li>
            <el-dropdown class="header-dropdown-devin" trigger="click">
              <span class="el-dropdown-link">
                <el-badge is-dot class="item ">
                  <el-button type="text" size="small"><i class="ti-bell"></i></el-button>
                </el-badge>
              </span>
              <el-dropdown-menu slot="dropdown">
                <ul class="dropdown-menu-devin">
                  <li class="header">You have 10 notifications</li>
                  <li>
                    <ul class="menu">
                      <li> <i class="ti-announcement"></i>
                          <a href="#">
                              <h3>Announcements <span class="text-green fontello-record"></span>
                                  </h3>
                              <p>Just Now !</p>
                          </a>
                      </li>
                      <li> <i class="ti-user"></i>
                          <a href="#">
                              <h3>Complete your profile<span class="text-yellow fontello-record"></span>
                                  </h3>
                              <p>2 Min Ago</p>
                          </a>
                      </li>
                      <li> <i class="ti-notepad"></i>
                          <a href="#">
                              <h3>New Schedule Realease<span class="text-yellow fontello-record"></span>
                                  </h3>
                              <p>30 Min ago</p>
                          </a>
                      </li>
                      <li> <i class="ti-agenda"></i>
                          <a href="#">
                              <h3>New User Data<span class="text-orange fontello-record"></span>
                                  </h3>
                              <p>1 Hour ago</p>
                          </a>
                      </li>
                      <li> <i class="ti-package"></i>
                          <a href="#">
                              <h3>New User List<span class="fontello-record"></span>
                                  </h3>
                              <p>2 Days ago</p>
                          </a>
                      </li>
                    </ul>
                  </li>
                  <li class="footer"><a href="#">View all</a></li>
                </ul>
              </el-dropdown-menu>
            </el-dropdown>
          </li>-->
        </ul>
      </div>
    </nav>
  </header>
</template>
<script>
  export default {
    name: 'DashboardHeader',
    methods: {
      handleLogout () {
        this.$store.dispatch('LOGOUT', this.$router)
      }
    }
  }
</script>
<style lang="scss">
  .navbar-custom-menu {
    margin-right: 20px;
  }
  .session-profile {
    margin-top: 12px;
    img {
      width: 48px;
      border-radius: 50%;
      border: 2px solid #eee;
    }
    .el-dropdown {
      top: 0
    }
  }
  .auth-tag {
    background-color: #3f9eff;
    color: white;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 13px;
    margin: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?b11c4a5e